// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__r1D6I","fillColor":"IconSuccess_fillColor__1_kwJ"};